import { handleActions } from "redux-actions";
import {
  getRangeOptions,
  getSelectedRangeOption,
  getDateRanges,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

import {
  SET_LOADING,
  SET_DATES,
  UPDATE_DATES,
  CLEAR_DATA,
  SET_CHART_LOADING,
  UPDATE_FILTERS,
  DISPLAY_ERROR,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTER_DATA_SUCCESS,
  FETCH_OFFERS_DATA_SUCCESS,
  UPDATE_CUSTOM_RANGE
} from "./challengerConversionSaga";

let offersData = [];
let normalizedData = [[], [], [], [], []];

function cleanFilters(data) {
  return data.map((item) => ({ id: item.id, name: item.productName }));
}

function setDefaultFilters(data) {
  return cleanFilters(data).slice(0, 6);
}

function pushOffers(data) {
  offersData.push(data);
  return offersData;
}

function clearData(data) {
  if (data) {
    offersData = [];
    normalizedData = [[], [], [], [], []];
  }
  return offersData;
}

function filterSelectedFiltersByNewFilters(selectedFilters, filters) {
  const filterIds = filters.map((f) => f.id);

  return selectedFilters.filter((f) => filterIds.includes(f.id));
}

function normalizeData(data) {
  if (normalizedData[0].length <= 5) {
    normalizedData[0].push(data.productName);
    normalizedData[1].push([
      data.challengersSold, //value
      data.challengersSoldTitle, //tooltip
      data.challengersSoldRawDataLink
    ]);
    normalizedData[2].push([
      data.challengersConvertedToServices,
      data.challengersConvertedToServicesTitle,
      data.challengersConvertedToServicesRawDataLink
    ]);
    normalizedData[3].push([
      data.challengersConvertedToMemberships,
      data.challengersConvertedToMembershipsTitle,
      data.challengersConvertedToMembershipsRawDataLink
    ]);
    normalizedData[4].push([
      data.allTimeRevenue,
      data.allTimeRevenueTitle,
      data.allTimeServicesRevenueTitle,
      data.allTimeProductsRevenueTitle,
      data.allTimeRevenueRawDataLink
    ]);
  }

  return normalizedData;
}

export const initialState = {
  currentUser: {},
  isLoading: true,
  initialRequest: false,
  isChartLoading: true,
  filtersDirty: false,
  datesDirty: false,
  rawFilters: [],
  filters: [],
  selectedFilters: [],
  selectedRequestDates: {},
  offersData: [],
  offersDataNormalized: [],
  error: false,
  conversionInfo: {},
  rangeOptions: [],
  selectedRangeOption: {},
  filtersInit: false
};

export default handleActions(
  {
    [CLEAR_DATA]: (state, action) => ({
      ...state,
      offersData: clearData(action.payload)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      datesDirty: true
    }),
    [DISPLAY_ERROR]: (state) => ({
      ...state,
      error: true,
      isLoading: false,
      isChartLoading: false,
      filtersDirty: false,
      datesDirty: false
    }),
    [UPDATE_FILTERS]: (state, action) => ({
      ...state,
      selectedFilters: action.payload,
      filtersDirty: true
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_CHART_LOADING]: (state, action) => ({
      ...state,
      isChartLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      datesDirty: true
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      filtersDirty: false,
      datesDirty: false,
      initialRequest: true
    }),
    [FETCH_FILTER_DATA_SUCCESS]: (state, action) => {
      const filters = cleanFilters(action.payload.data) || state.filters;

      return {
        ...state,
        rawFilters: action.payload.data,
        filters,
        selectedFilters: action.payload.usePrevSelectedFilters
          ? filterSelectedFiltersByNewFilters(state.selectedFilters, filters)
          : setDefaultFilters(action.payload.data)
      };
    },
    [FETCH_OFFERS_DATA_SUCCESS]: (state, action) => ({
      ...state,
      offersData: pushOffers(action.payload) || state.offersData,
      offersDataNormalized: normalizeData(action.payload),
      filtersDirty: false,
      datesDirty: false,
      error: false
    })
  },
  initialState
);
